import { render, staticRenderFns } from "./VincularPerfil.vue?vue&type=template&id=5717aad0&"
import script from "./VincularPerfil.vue?vue&type=script&lang=js&"
export * from "./VincularPerfil.vue?vue&type=script&lang=js&"
import style0 from "./VincularPerfil.vue?vue&type=style&index=0&id=5717aad0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports